import { Companion_getInstancel4ymxmn2l08f as Companion_getInstance } from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/HttpMethod.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1x79l67jvwntn as serializer_1,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  serializer1wpgysz06u9ol as serializer_2,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance2v6degzrm2jsl as Companion_getInstance_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModelPermissions.mjs';
import { Companion_getInstance3jmcdc9kv8nln as Companion_getInstance_1 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { Companion_getInstancemcidlsfrtpdg as Companion_getInstance_2 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/MassModification.mjs';
import {
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
  DoubleCompanionObject_instance43opzxl97v4p as DoubleCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instance7x85vjcu6250 as Companion_instance } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Modification.mjs';
import { Companion_instance170wh3hu8c61 as Companion_instance_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  Companion_getInstance3oqgrjvfi17jk as Companion_getInstance_3,
  Companion_getInstance3ouvgkx7lgis5 as Companion_getInstance_4,
  Companion_getInstance1qfdwb51f0ue as Companion_getInstance_5,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/GroupCountQuery.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ClientModelRestUpdatesWebSocket3jbuy8au3ubru as ClientModelRestUpdatesWebSocket } from './ClientModelRestEndpoints.mjs';
import { Companion_getInstancelkcs3vv5v0ys as Companion_getInstance_6 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/CollectionUpdates.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function url($this, $receiver) {
  return $this.fetcher_1.url_tsvlb2_k$($receiver, $this.idSerializer_1);
}
var LiveClientModelRestEndpointsClass;
function LiveClientModelRestEndpoints() {
  if (LiveClientModelRestEndpointsClass === VOID) {
    class $ {
      constructor(fetcher, subpath, serializer, idSerializer) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
        this.serializer_1 = serializer;
        this.idSerializer_1 = idSerializer;
      }
      *permissions_x4pqz_k$($completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/_permissions_', Companion_getInstance().GET_1, serializer(Unit_instance), Unit_instance, Companion_getInstance_0().serializer_nrleg8_k$(this.serializer_1), $completion);
      }
      *query_o986pg_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/query', Companion_getInstance().POST_1, Companion_getInstance_1().serializer_qelnde_k$(this.serializer_1), input, ListSerializer(this.serializer_1), $completion);
      }
      *insertBulk_vz3d8k_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/bulk', Companion_getInstance().POST_1, ListSerializer(this.serializer_1), input, ListSerializer(this.serializer_1), $completion);
      }
      *insert_a1u7p6_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1, Companion_getInstance().POST_1, this.serializer_1, input, this.serializer_1, $completion);
      }
      *bulkModify_ugvnv2_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/bulk', Companion_getInstance().PATCH_1, Companion_getInstance_2().serializer_qelnde_k$(this.serializer_1), input, serializer_0(IntCompanionObject_instance), $completion);
      }
      *modify_ntk3hh_k$(id, input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/' + url(this, id), Companion_getInstance().PATCH_1, Companion_instance.serializer_qelnde_k$(this.serializer_1), input, this.serializer_1, $completion);
      }
      *delete_xs5ou5_k$(id, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/' + url(this, id), Companion_getInstance().DELETE_1, serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      *count_q0vep4_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/count', Companion_getInstance().POST_1, Companion_instance_0.serializer_qelnde_k$(this.serializer_1), input, serializer_0(IntCompanionObject_instance), $completion);
      }
      *groupCount_z3zpjq_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/group-count', Companion_getInstance().POST_1, Companion_getInstance_3().serializer_nrleg8_k$(this.serializer_1), input, MapSerializer(serializer_1(StringCompanionObject_instance), serializer_0(IntCompanionObject_instance)), $completion);
      }
      *aggregate_x3h2lp_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/aggregate', Companion_getInstance().POST_1, Companion_getInstance_4().serializer_nrleg8_k$(this.serializer_1), input, get_nullable(serializer_2(DoubleCompanionObject_instance)), $completion);
      }
      *groupAggregate_efln9_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/group-aggregate', Companion_getInstance().POST_1, Companion_getInstance_5().serializer_nrleg8_k$(this.serializer_1), input, MapSerializer(serializer_1(StringCompanionObject_instance), get_nullable(serializer_2(DoubleCompanionObject_instance))), $completion);
      }
    }
    initMetadataForClass($, 'LiveClientModelRestEndpoints', VOID, VOID, VOID, [0, 1, 2]);
    LiveClientModelRestEndpointsClass = $;
  }
  return LiveClientModelRestEndpointsClass;
}
var LiveClientModelRestEndpointsAndUpdatesWebSocketClass;
function LiveClientModelRestEndpointsAndUpdatesWebSocket() {
  if (LiveClientModelRestEndpointsAndUpdatesWebSocketClass === VOID) {
    class $ {
      constructor(fetcher, subpath, serializer, idSerializer) {
        this.$$delegate_0__1 = new (LiveClientModelRestEndpoints())(fetcher, subpath, serializer, idSerializer);
        this.$$delegate_1__1 = new (LiveClientModelRestUpdatesWebSocket())(fetcher, subpath, serializer, idSerializer);
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
        this.serializer_1 = serializer;
        this.idSerializer_1 = idSerializer;
      }
      *query_o986pg_k$(input, $completion) {
        return yield* this.$$delegate_0__1.query_o986pg_k$(input, $completion);
      }
      *insertBulk_vz3d8k_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insertBulk_vz3d8k_k$(input, $completion);
      }
      *insert_a1u7p6_k$(input, $completion) {
        return yield* this.$$delegate_0__1.insert_a1u7p6_k$(input, $completion);
      }
      *bulkModify_ugvnv2_k$(input, $completion) {
        return yield* this.$$delegate_0__1.bulkModify_ugvnv2_k$(input, $completion);
      }
      *modify_ntk3hh_k$(id, input, $completion) {
        return yield* this.$$delegate_0__1.modify_ntk3hh_k$(id, input, $completion);
      }
      *delete_xs5ou5_k$(id, $completion) {
        yield* this.$$delegate_0__1.delete_xs5ou5_k$(id, $completion);
        return Unit_instance;
      }
      *count_q0vep4_k$(input, $completion) {
        return yield* this.$$delegate_0__1.count_q0vep4_k$(input, $completion);
      }
      *groupCount_z3zpjq_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupCount_z3zpjq_k$(input, $completion);
      }
      *aggregate_x3h2lp_k$(input, $completion) {
        return yield* this.$$delegate_0__1.aggregate_x3h2lp_k$(input, $completion);
      }
      *groupAggregate_efln9_k$(input, $completion) {
        return yield* this.$$delegate_0__1.groupAggregate_efln9_k$(input, $completion);
      }
      *permissions_x4pqz_k$($completion) {
        return yield* this.$$delegate_0__1.permissions_x4pqz_k$($completion);
      }
      updates_3vknjq_k$() {
        return this.$$delegate_1__1.updates_3vknjq_k$();
      }
    }
    initMetadataForClass($, 'LiveClientModelRestEndpointsAndUpdatesWebSocket', VOID, VOID, [ClientModelRestUpdatesWebSocket()], [0, 1, 2]);
    LiveClientModelRestEndpointsAndUpdatesWebSocketClass = $;
  }
  return LiveClientModelRestEndpointsAndUpdatesWebSocketClass;
}
var LiveClientModelRestUpdatesWebSocketClass;
function LiveClientModelRestUpdatesWebSocket() {
  if (LiveClientModelRestUpdatesWebSocketClass === VOID) {
    class $ {
      constructor(fetcher, subpath, serializer, idSerializer) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
        this.serializer_1 = serializer;
        this.idSerializer_1 = idSerializer;
      }
      updates_3vknjq_k$() {
        return this.fetcher_1.webSocket_nkn44m_k$(this.subpath_1, Companion_instance_0.serializer_qelnde_k$(this.serializer_1), Companion_getInstance_6().serializer_cre5l3_k$(this.serializer_1, this.idSerializer_1));
      }
    }
    initMetadataForClass($, 'LiveClientModelRestUpdatesWebSocket', VOID, VOID, [ClientModelRestUpdatesWebSocket()]);
    LiveClientModelRestUpdatesWebSocketClass = $;
  }
  return LiveClientModelRestUpdatesWebSocketClass;
}
//region block: exports
export {
  LiveClientModelRestEndpointsAndUpdatesWebSocket as LiveClientModelRestEndpointsAndUpdatesWebSocket2xmxa2mxjm57q,
  LiveClientModelRestEndpoints as LiveClientModelRestEndpoints1iiraf6ocg5qo,
};
//endregion

//# sourceMappingURL=LiveClientModelRestEndpoints.mjs.map
